var map = {
	"./airbnbLogo.png": 3783,
	"./codeInLogo.webp": 7008,
	"./contactMail.webp": 9729,
	"./contactMailDark.svg": 3527,
	"./developerActivity.svg": 36,
	"./facebookLogo.png": 34,
	"./fastapiLogo.svg": 1392,
	"./foxconn.jpg": 5854,
	"./gcpLogo.svg": 338,
	"./googleAssistant.svg": 760,
	"./googleAssistantLogo.webp": 2905,
	"./granfaculdadeLogo.png": 5393,
	"./ifamLogo.png": 1074,
	"./jsFramework.svg": 860,
	"./manOnTable.svg": 8776,
	"./mongoLogo.svg": 1529,
	"./mysqlLogo.svg": 2221,
	"./nextuLogo.webp": 2953,
	"./perotedev2.png": 2247,
	"./perotedev3.png": 9414,
	"./pmamLogo.png": 2081,
	"./postgreLogo.svg": 4050,
	"./programmer.svg": 522,
	"./projexLogo.jpg": 9194,
	"./pwa.webp": 930,
	"./pwaLogo.webp": 9943,
	"./quoraLogo.png": 8967,
	"./saayaHealthLogo.webp": 7788,
	"./skill.svg": 1601,
	"./springbootLogo.svg": 7105,
	"./stanfordLogo.png": 7021,
	"./talksCardBack.svg": 2592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;